module.exports = __webpack_public_path__ + "img/pinefall.a1b33c7d.png";